module.exports = __webpack_public_path__ + "static/img/gongzhonghao.82a3652c.png";